import React from "react";
import "./Pagination.css";

interface PaginationProps {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}

const Pagination: React.FC<PaginationProps> = ({
  hasMore,
  loading,
  onLoadMore,
}) => {
  if (!hasMore) return null;

  return (
    <div className="pagination-container">
      <button className="btn-load-more" onClick={onLoadMore} disabled={loading}>
        {loading ? "Carregando..." : "Carregar mais faturas"}
      </button>
    </div>
  );
};

export default Pagination;
